// languages/japanese.js
export const japanese = {
  name: "日本語",
  interface: {
    welcome: "ようこそ",
    chooseLanguage: "言語を選択",
    continue: "続行",
    backToMap: "地図に戻る",
    achievement: "成果",
    viewInAR: "ARで見る",
    menu: {
      menu: "メニュー",
      home: "ホーム",
      language: "言語",
      achievement: "成果",
      unsuiExperience: "雲水体験",
      feedback: "フィードバック",
    },
    buyScreen: {
      clickToBuy: "特別な体験を購入",
      templeExperience: "萬福寺で！",
      description1: "オーディオガイドで萬福寺の",
      description2: "魅力的なストーリーを聞いて",
      description3: "ARを楽しもう！",
      buy: "購入",
    },
    gift: {
      congratulations: "おめでとう！",
      yourGift: "ギフト",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
